import config from "./config";
import { get } from "../lib/fetchUtil";

const { sitecoreHost } = config;

export async function authentication(provider) {
  const response = await get(`authentication/login/${provider}`);

  return await response.json();
}

export function authenticationUrl(input) {
  return `${sitecoreHost}${input}`;
}
